import { FC, Fragment } from 'react'
import { LargeProductSuitCardsData } from '../types'
import { Stack, theme } from '@dtx-company/design-system/src'
import LargeProductSuitCard from './LargeProductSuitCard'

//sectionId is used for navigation
const LargeProductSuitCardsSection: FC<{
  data?: LargeProductSuitCardsData
  sectionId: string
}> = ({ data, sectionId }) => {
  if (!data) return null

  return (
    <Stack
      id={sectionId}
      spacing={{
        xs: theme.spacing(14)
      }}
      direction="column"
      justifyContent="center"
      sx={{
        my: {
          _: theme.spacing(8),
          md: theme.spacing(14),
          lg: theme.spacing(24)
        }
      }}
    >
      {data?.items?.map((item, index) => (
        <Fragment key={`${item.subheader}_${index}`}>
          <LargeProductSuitCard data={item} />
        </Fragment>
      ))}
    </Stack>
  )
}

export default LargeProductSuitCardsSection
